import { Button } from 'module/ui/components/atoms/button/button';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

const PagePreviewHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--spacing-03);
`;

interface PreviewHeaderProps {
  onClose: () => void;
}

export const PreviewHeader: React.FC<PreviewHeaderProps> = ({ onClose }) => {
  return (
    <PagePreviewHeaderWrapper>
      <Button
        icon={<FontAwesomeIcon icon={faChevronLeft} size={12} />}
        onClick={onClose}
      />
    </PagePreviewHeaderWrapper>
  );
};
